<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Tìm kiếm nâng cao
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Nhân sự" prop="userDeptRoleId">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.userDeptRoleId"
                placeholder="Gõ để tìm kiếm"
                size="medium"
                remote
                reserve-keyword
                :remote-method="searchUserDeptRole"
                :loading="isSearchUserDeptRole"
                filterable
                clearable
              >
                <el-option
                  v-for="item in userDeptRoles"
                  :key="item.id"
                  :label="
                    `${item.fullName} (${item.positionName} - ${item.deptName})`
                  "
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Lý do" prop="rankingReasonId">
              <el-select
                class="style-fullWidth input-border__bottom input-border__radius__0"
                v-model="advanceSearchForm.rankingReasonId"
                placeholder="-"
                size="medium"
                filterable
                clearable
                @change="rankingReasonIdChanged"
              >
                <el-option-group
                  v-for="group in rankingReasonGroups"
                  :key="group.value"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.rankingReasons"
                    :key="item.id"
                    :label="`(${getTypeLabel(item.type)}) ${item.name}`"
                    :value="item.id"
                  ></el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Cộng/trừ điểm" prop="type">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="advanceSearchForm.type"
                placeholder="Cộng/trừ điểm"
                size="medium"
                :disabled="!!advanceSearchForm.rankingReasonId"
                clearable
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Loại" prop="scoreType">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="advanceSearchForm.scoreType"
                placeholder="Chuyên môn/nguyên tắc"
                size="medium"
                :disabled="!!advanceSearchForm.rankingReasonId"
                clearable
              >
                <el-option
                  v-for="item in scoreTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="Ngày đánh giá">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                format="dd/MM/yyyy"
                class="style-fullWidth  input-border__bottom input-border__radius__0"
                :picker-options="dateQuickFilterOption"
                range-separator="_"
                start-placeholder="_"
                end-placeholder="_"
                align="right"
                :clearable="false"
                size="large"
                @change="dateRangeChanged"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fal fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
        >Khởi tạo
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../constants";
import utils from "../../services/utils";
import dateUtils from "../../dateUtils";
import CustomDialog from "../common/custom-dialog";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import rankingUtils from "../../services/rankingUtils";
import rankingReasonService from "../../services/rankingReasonService";
import h from "../../services/h";

export default {
  name: "ranking-score-advance-search-dialog",
  props: ["isOpen", "form"],
  components: {
    CustomDialog
  },

  data() {
    return {
      advanceSearchForm: {
        userDeptRoleId: null,
        rankingReasonId: null,
        type: null,
        scoreType: null,
        fromDate: null,
        toDate: null
      },
      dateRange: null,
      isSearchUserDeptRole: false,
      userDeptRoles: [],
      typeOptions: [],
      scoreTypeOptions: [],
      dateQuickFilterOption: null,
      rankingReasons: [],
      rankingReasonGroups: []
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    deptId() {
      return this.userDeptRole ? this.userDeptRole.deptId : null;
    }
  },

  watch: {},

  created() {
    this.initOptions();
    this.initDateQuickFilterOption();
    this.initForm();
    this.initUserDeptRoles();
    this.loadRankingReasons(this.deptId).then(rankingReasons =>
      this.initRankingReasonGroups(rankingReasons)
    );
  },

  methods: {
    getTypeLabel(type) {
      return rankingUtils.getTypeLabel(type);
    },

    rankingReasonIdChanged() {
      if (this.advanceSearchForm.rankingReasonId) {
        let rankingReason = h.find(
          this.rankingReasons,
          rankingReason_ =>
            rankingReason_.id === this.advanceSearchForm.rankingReasonId
        );

        this.advanceSearchForm.type = rankingReason.type;
        this.advanceSearchForm.scoreType = rankingReason.scoreType;
      }
    },

    loadRankingReasons(deptId) {
      return rankingReasonService
        .findAll({
          deptId: deptId,
          status: constants.STATUS_.ACTIVE
        })
        .then(response => (this.rankingReasons = response.data));
    },

    initRankingReasonGroups() {
      this.rankingReasonGroups = h.collect(
        [
          constants.RANKING_REASON.SCORE_TYPE.CHUYENMON,
          constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC
        ],
        type => {
          return {
            value: type,
            label: rankingUtils.getScoreTypeLabel(type),
            rankingReasons: h.findAll(
              this.rankingReasons,
              rankingReason => rankingReason.scoreType === type
            )
          };
        }
      );
    },

    initUserDeptRoles() {
      return (this.advanceSearchForm.userDeptRoleId
          ? userDeptRoleViewService
            .findById(this.advanceSearchForm.userDeptRoleId)
            .then(response => response.data)
          : Promise.resolve(null)
      ).then(
        userDeptRole =>
          (this.userDeptRoles = userDeptRole ? [userDeptRole] : null)
      );
    },

    initDateRange() {
      if (this.advanceSearchForm.fromDate && this.advanceSearchForm.toDate) {
        this.dateRange = [
          dateUtils.toMoment(this.advanceSearchForm.fromDate),
          dateUtils.toMoment(this.advanceSearchForm.toDate)
        ];
      } else {
        this.dateRange = dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
        );
        this.advanceSearchForm.fromDate = defaultTimeRange[0];
        this.advanceSearchForm.toDate = defaultTimeRange[1];
      }
    },

    dateRangeChanged() {
      this.advanceSearchForm.fromDate =
        this.dateRange && this.dateRange[0]
          ? this.dateRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toDate =
        this.dateRange && this.dateRange[1]
          ? this.dateRange[1].getTime()
          : undefined;
      this.initDateRange();
    },

    initDateQuickFilterOption() {
      this.dateQuickFilterOption = {
        shortcuts: [
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.THIS_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
          ),
          utils.buildDateQuickFilterOption(
            constants.DATE_QUICK_FILTER.CODE.NAM_NAY
          )
        ]
      };
    },

    initOptions() {
      this.typeOptions = rankingUtils.initTypeOptions();
      this.scoreTypeOptions = rankingUtils.initScoreTypeOptions();
    },

    searchUserDeptRole(query) {
      this.isSearchUserDeptRole = true;
      (query && query.trim()
          ? userDeptRoleViewService
            .findAllForRankingScore(query)
            .then(response => response.data)
          : Promise.resolve([])
      )
        .then(userDeptRoles => (this.userDeptRoles = userDeptRoles))
        .then(() => (this.isSearchUserDeptRole = false))
        .catch(() => (this.isSearchUserDeptRole = false));
    },

    initForm() {
      this.advanceSearchForm.userDeptRoleId = this.form.userDeptRoleId;
      this.advanceSearchForm.rankingReasonId = this.form.rankingReasonId;
      this.advanceSearchForm.type = this.form.type;
      this.advanceSearchForm.scoreType = this.form.scoreType;
      this.advanceSearchForm.fromDate = this.form.fromDate;
      this.advanceSearchForm.toDate = this.form.toDate;
      this.initDateRange();
    },

    search() {
      let advanceSearchForm = {
        userDeptRoleId: utils.nvl(
          this.advanceSearchForm.userDeptRoleId,
          undefined
        ),
        rankingReasonId: utils.nvl(
          this.advanceSearchForm.rankingReasonId,
          undefined
        ),
        type: utils.nvl(this.advanceSearchForm.type, undefined),
        scoreType: utils.nvl(this.advanceSearchForm.scoreType, undefined),
        fromDate: utils.nvl(this.advanceSearchForm.fromDate, undefined),
        toDate: utils.nvl(this.advanceSearchForm.toDate, undefined)
      };
      this.$emit("doSearch", {advanceSearchForm: advanceSearchForm});
      this.$emit("closeDialog");
    },

    reset() {
      this.advanceSearchForm.userDeptRoleId = null;
      this.advanceSearchForm.rankingReasonId = null;
      this.advanceSearchForm.type = null;
      this.advanceSearchForm.scoreType = null;
      this.advanceSearchForm.fromDate = null;
      this.advanceSearchForm.toDate = null;
      this.initDateRange();
    }
  }
};
</script>

<style scoped>
.form {
  padding: 12px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/ranking-score/ranking-score-advance-search-dialog.vue